import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

const useSetCollateralModalParams = () => {
	const set = useDriftStore((s) => s.set);
	const accountsSet = useDriftAccountStore((s) => s.set);

	const setCollateralModalParams = (
		modalName: string,
		collateralTypeIndex: number,
		targetAccountKey: string
	) => {
		set((s) => {
			s.modals[modalName] = true;

			// this parent function is expected to be called from a CTA that is linked to an asset
			// hence we want to default the  asset to the asset that was clicked
			if (
				modalName === 'showWithdrawModal' ||
				modalName === 'showDepositModal'
			) {
				s.modalsProps[modalName] = {
					defaultMax: false,
				};
			}

			s.modalCollateralType = collateralTypeIndex;
			s.modalTargetAccountKey = targetAccountKey;
		});
		accountsSet((s) => {
			s.currentUserKey = targetAccountKey;
		});
	};

	return setCollateralModalParams;
};

export default useSetCollateralModalParams;
